import '../styles/Quotes.css'
import { columnsQuotes, columnsInventoryAdmin } from '../Component/Hooks/ColumTables'
import Table from '../Component/Tabla/Tabla'
import { useContext, useEffect, useState } from 'react'
import LoginContext from '../Context/Logincontext';
import { urlApiServer } from '../Config/Config'
import Loader from '../Component/Loader';
import EditInventory from '../Component/Hooks/EditInventory';

const Inventory = () => {

    const urlGetClient = urlApiServer + "historyproduct"
    const urlgetInventorys = urlApiServer + "getinventory"
    const urlgetConfig = urlApiServer + "getConfig";
    const urlGetRemission = urlApiServer + "getRemission"
    const urlGetCompany = urlApiServer + "company"

    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [inventoryGetTable, setInventoryGetTable] = useState([])
    const [filterTable, setFilterTable] = useState([])
    const [state, setState] = useState("0")
    const [powerEdit, setPowerEdit] = useState(true)
    const [powerandoff, setPowerandoff] = useState(true)
    const [id, setId] = useState()
    const [oldConfig, setOldConfig] = useState("")
    const [dataRemission, setDateRemission] = useState([])
    const [company, setCompany] = useState([])
    const [disabledBottom, setDisabledBottom] = useState(false);


    useEffect(() => {
        (async function () {

            if (infoUser.login !== true) {
                window.location.href = './Login'
            }

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }
            await fetch(urlgetConfig, requesoption).then(response => response.json()).then(quotesResponse => {
                setOldConfig(quotesResponse)
            })
        }())
    }, [])



    useEffect(() => {
        (async function () {
            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json");
            InicioHeaders.append("company", infoUser.company); // Enviar el nombre de la empresa como encabezado

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            };

            await fetch(urlgetInventorys, requesoption)
                .then(response => response.json())
                .then(quotesResponse => {
                    console.log("quotesResponse: ", quotesResponse)
                    setInventoryGetTable(quotesResponse.reverse());
                })
                .catch(error => {
                });
        }())

    }, [state, urlGetClient, urlgetInventorys, powerEdit])

    useEffect(() => {
    }, [filterTable])

    useEffect(() => {
        if (disabledBottom) {
            if (powerandoff === true) {
                setPowerandoff(false)
            } else {
                setPowerandoff(true)
            }
        }
    }, [disabledBottom])

    async function edit() {
        if (powerEdit === true) {
            setPowerEdit(false)
        } else {
            setPowerEdit(true)
        }
    }

    async function handleId(e) {
        setId(e)
    }

    return (
        <>
            {
                (infoUser.companyType === "Marmol") && (
                    (disabledBottom) && (
                        <div className="backgroundLoader">
                            <Loader />
                        </div>
                    )
                )
            }
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    (powerEdit === true) ? (

                        <>
                            {(infoUser.role === 'Administrador') ? (
                                <>

                                    <Table columns={columnsInventoryAdmin} data={inventoryGetTable} edit={edit} id={handleId} />
                                </>
                            ) : (
                                <>
                                    <Table columns={columnsQuotes} data={inventoryGetTable} />
                                </>
                            )}
                        </>
                    ) : (
                        (<EditInventory id={id} edit={edit}/>)
                        // (infoUser.companyType === "Generico") && (<EditInventory id={id} />)

                    )
                )
            ) : (<></>)}
        </>
    )
}

export default Inventory